// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".color--primary[data-v-762cfc09]{color:#c81919}.modal--container[data-v-762cfc09]{min-height:600px}.subtitle--text[data-v-762cfc09]{margin-top:20px}@media only screen and (max-width: 768px){.subtitle--text[data-v-762cfc09]{margin-top:60px;text-align:center}}.add--button[data-v-762cfc09]{margin-bottom:36px}", ""]);
// Exports
module.exports = exports;
